export default __webpack_public_path__ + "static/media/finish-success.bd5b0ae1.svg";